import { selectChannelsState } from "redux/channels/selectors/selectChannelsState";
import { createSelector } from "reselect";

export const selectAllSimpleSupervisor = createSelector([selectChannelsState], (state) => state.allSupervisors);
